export default "/images/ce2b80a853f1e7cbb700aa17418bd69f.jpg";